











import Vue from "vue";
export default Vue.extend({
  props: {
    label: {
      type: String,
      default: "新規作成",
    },
  },
  methods: {
    handleOnClick() {
      this.$emit("click");
    },
  },
});
